export default __webpack_public_path__ + "static/media/t.c8eb3d7f.svg";